// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1vgJA","content":"RecentSearches_content__1BSf1"};